import { ParameterDefinition } from '@automata/wfb-api/src/apis/wfbApiSchemas';
import { MenuItem, Typography } from '@mui/material';

import { getParameterValueStr } from '../../../../utils/parameters';
import {
  getParameterIcon,
  getParameterType,
} from '../../../GraphEditorToolbars/ParametersToolbar/utils';

interface ExposingParameterMenuItemProps {
  isSelected?: boolean;
  parameter: ParameterDefinition;
  onClick: (paramName: string) => void;
}

export const ExposingParameterMenuItem = ({
  isSelected,
  parameter,
  onClick,
}: ExposingParameterMenuItemProps) => {
  const defaultValue = getParameterValueStr(parameter);
  const parameterType = getParameterType(parameter);
  return (
    <MenuItem selected={isSelected} onClick={() => onClick(parameter?.name)}>
      {getParameterIcon(parameterType)}
      <Typography marginLeft={1} flex={1} variant="body1">
        {parameter.name}
      </Typography>
      <Typography marginLeft={1} variant="body1" color="neutral.600">
        {defaultValue}
      </Typography>
    </MenuItem>
  );
};
